// extracted by mini-css-extract-plugin
export default {"column-layout":"styles_column-layout__8DHYq","reverse":"styles_reverse__a0UPD"};